import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ProSidebarProvider } from "react-pro-sidebar";

// import Header from "./Header/Header";
// import Footer from "./Footer/footer";
import NavBar from "../../components/NavBar/NavBar";
import ChangeStoreHeader from "../../containers/ChangeStoreHeader/ChangeStoreHeader";

// Styles Import
import styles from "./index.module.css";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";

const Layout = ({ children }) => {
  const { loading } = useSelector((state) => state.fullPageLoaderSlice);
  return (
    <>
      <ThemeProvider theme={{ fontFamily: "Poppins" }}>
        <div className="d-lg-flex d-sm-flex">
          <ProSidebarProvider>
            <NavBar />
          </ProSidebarProvider>
          {/* <Header /> */}
          <main className={styles.main}>
            <div className="container">
              <ChangeStoreHeader />
            </div>
            {children}
            {loading ? <FullPageLoading /> : null}
          </main>
        </div>
        {/* <Footer /> */}
      </ThemeProvider>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default Layout;
